import type { BillingMilestone } from '../types/agreement'

export function roundMoney(value: number): number {
  return Math.round(value * 100) / 100
}

export function computeMilestoneAmounts(total: number, milestones: BillingMilestone[]): BillingMilestone[] {
  const safeTotal = Number(total) || 0
  return milestones.map((m, index) => ({
    ...m,
    sort_order: index,
    amount: roundMoney((safeTotal * Number(m.percentage || 0)) / 100),
  }))
}

export function sumMilestonePercentages(milestones: BillingMilestone[]): number {
  return milestones.reduce((sum, m) => sum + Number(m.percentage || 0), 0)
}

export function validateMilestoneSchedule(milestones: BillingMilestone[]): string[] {
  const errors: string[] = []
  if (!milestones || milestones.length === 0) {
    errors.push('Add at least one billing milestone.')
    return errors
  }
  milestones.forEach((m, i) => {
    if (!m.label?.trim()) {
      errors.push(`Milestone ${i + 1} needs a label.`)
    }
    const pct = Number(m.percentage)
    if (!pct || pct <= 0 || pct > 100) {
      errors.push(`Milestone ${i + 1} percentage must be between 0 and 100.`)
    }
  })
  const totalPct = sumMilestonePercentages(milestones)
  if (Math.abs(totalPct - 100) > 0.01) {
    errors.push(`Milestone percentages must total 100% (currently ${totalPct.toFixed(1)}%).`)
  }
  return errors
}

export function copyMilestonesForTotal(milestones: BillingMilestone[], newTotal: number): BillingMilestone[] {
  return computeMilestoneAmounts(
    newTotal,
    milestones.map((m, index) => ({
      ...m,
      id: `new-${Date.now()}-${index}`,
      status: 'pending',
      invoice_id: null,
      invoiced_at: null,
    }))
  )
}
